<template>
  <header
    class="w-full bg-mocha-mousse-50/90 backdrop-blur-md shadow-sm border-b border-mocha-mousse-200 sticky top-0 z-50"
  >
    <div
      class="max-w-7xl mx-auto px-3 sm:px-6 py-2 flex items-center justify-between gap-2 min-w-0"
    >
      <!-- Left: logo + breadcrumb -->
      <div class="flex items-center gap-2 sm:gap-4 min-w-0">
        <RouterLink
          :to="{ name: 'HomePage' }"
          class="shrink-0 flex items-center group"
        >
          <img
            :src="logo"
            alt="Enodo"
            class="w-20 drop-shadow-sm transition-transform group-hover:scale-105"
          />
        </RouterLink>

        <!-- breadcrumb: hidden on very small screens if too crowded -->
        <div class="min-w-0 hidden sm:block">
          <Breadcrumb />
        </div>
      </div>

      <!-- Right: account -->
      <div class="shrink-0">
        <slot name="account">
          <LoginDropdown />
        </slot>
      </div>
    </div>

    <!-- Breadcrumb shown below logo row on xs screens -->
    <div class="sm:hidden border-t border-mocha-mousse-100">
      <Breadcrumb />
    </div>
  </header>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { RouterLink } from "vue-router";
import { Icon } from "@iconify/vue";
import Breadcrumb from "./Breadcrumb.vue";
import LoginDropdown from "./LoginDropdown.vue";

const props = defineProps({
  logo: { type: String, required: true },
});
</script>
